import { BillingStrategy as BillingStrategySDK } from '@galaxy/billing';

/**
 * @deprecated Use BillingStrategy from @vendasta/billing
 */
export class BillingStrategy {
  static prepay = new BillingStrategy('charge-at-start-of-billing-period');
  static postpay = new BillingStrategy('charge-at-end-of-billing-period');
  static instant = new BillingStrategy('charge-instantly');
  static endOfDay = new BillingStrategy('charge-at-end-of-day');

  strategy: string;
  display: string;
  private billing: BillingStrategySDK;

  static allLevels(): BillingStrategy[] {
    return [this.prepay, this.postpay, this.instant, this.endOfDay];
  }

  static allProductLevels(): BillingStrategy[] {
    return [this.postpay, this.instant];
  }

  static fromBillingSDK(bs: BillingStrategySDK): BillingStrategy {
    let strategy = null;
    switch (bs) {
      case BillingStrategySDK.EndOfPeriod:
        strategy = 'charge-at-end-of-billing-period';
        break;
      case BillingStrategySDK.StartOfPeriod:
        strategy = 'charge-at-start-of-billing-period';
        break;
      case BillingStrategySDK.Instantly:
        strategy = 'charge-instantly';
        break;
      case BillingStrategySDK.EndOfDay:
        strategy = 'charge-at-end-of-day';
        break;
    }
    return new BillingStrategy(strategy);
  }

  static toBillingSDK(bs: BillingStrategy): BillingStrategySDK {
    let strategy: BillingStrategySDK;
    switch (bs) {
      case BillingStrategy.prepay:
        strategy = BillingStrategySDK.StartOfPeriod;
        break;
      case BillingStrategy.postpay:
        strategy = BillingStrategySDK.EndOfPeriod;
        break;
      case BillingStrategy.instant:
        strategy = BillingStrategySDK.Instantly;
        break;
      case BillingStrategy.endOfDay:
        strategy = BillingStrategySDK.EndOfDay;
        break;
      default:
        strategy = BillingStrategySDK.Invalid;
    }
    return strategy;
  }

  constructor(strategy: string) {
    this.strategy = strategy;
    switch (strategy) {
      case 'charge-at-end-of-billing-period':
        this.display = 'Postpay';
        this.billing = BillingStrategySDK.EndOfPeriod;
        break;
      case 'charge-at-start-of-billing-period':
        this.display = 'Prepay';
        this.billing = BillingStrategySDK.StartOfPeriod;
        break;
      case 'charge-instantly':
        this.display = 'Instant';
        this.billing = BillingStrategySDK.Instantly;
        break;
      case 'charge-at-end-of-day':
        this.display = 'End of Day';
        this.billing = BillingStrategySDK.EndOfDay;
        break;
      default:
        this.display = 'Unknown';
        this.billing = BillingStrategySDK.Invalid;
    }
  }

  public isNonInvoicedStrategy(): boolean {
    return this === BillingStrategy.instant || this === BillingStrategy.endOfDay;
  }

  public toCore(): BillingStrategySDK {
    return this.billing;
  }
}
